// Tiny GA4 wrapper. No-op in preview (gtag only loads on pocltc.org), so
// these calls are safe to litter throughout the app.
export function gaPageview(path) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path || window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function gaEvent(name, params) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  try { window.gtag('event', name, params || {}); } catch (_) { /* noop */ }
}
